<template>
  <v-card>
    <v-card-title class="headline">
      Información de folletos y materiales<br>
      <small>{{ local.lapCodigo }} - {{ local.local.nombre }}</small>
    </v-card-title>
    <v-card-text>
      <v-alert v-if="showAlert" color="warning" type="warning" class="mt-3">
        No hay caja asociada al local
      </v-alert>
      <div v-else-if="!infoCaja && !showAlert" class="text-center">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        />
      </div>
      <div v-else>
        <v-simple-table dense>
          <template #default>
            <thead>
              <tr>
                <th class="text-left" colspan="2">
                  <h3>FOLLETOS</h3>
                </th>
              </tr>
              <tr>
                <th class="text-left">
                  Prueba
                </th>
                <th class="text-center">
                  Cantidad
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>COMPETENCIA LECTORA</td>
                <td class="text-center">
                  {{ infoCaja.leng }}
                </td>
              </tr>
              <tr>
                <td>COMPETENCIA MATEMÁTICA (M1)</td>
                <td class="text-center">
                  {{ infoCaja.mate }}
                </td>
              </tr>
              <tr>
                <td>HISTORIA Y CS. SOCIALES</td>
                <td class="text-center">
                  {{ infoCaja.hcso }}
                </td>
              </tr>
              <tr>
                <td>CIENCIAS</td>
                <td class="text-center">
                  {{ infoCaja.cien }}
                </td>
              </tr>
              <tr>
                <td>COMPETENCIA MATEMÁTICA (M2)</td>
                <td class="text-center">
                  {{ infoCaja.mate2 }}
                </td>
              </tr>
              <tr>
                <td>COMPETENCIA LECTORA PESD</td>
                <td class="text-center">
                  {{ infoCaja.lengPesd }}
                </td>
              </tr>
              <tr>
                <td>COMPETENCIA MATEMÁTICA (M1) PESD</td>
                <td class="text-center">
                  {{ infoCaja.matePesd }}
                </td>
              </tr>
              <tr>
                <td>HISTORIA Y CS. SOCIALES PESD</td>
                <td class="text-center">
                  {{ infoCaja.hcsoPesd }}
                </td>
              </tr>
              <tr>
                <td>CIENCIAS PESD</td>
                <td class="text-center">
                  {{ infoCaja.cienPesd }}
                </td>
              </tr>
              <tr>
                <td>COMPETENCIA MATEMÁTICA (M2) PESD</td>
                <td class="text-center">
                  {{ infoCaja.mate2Pesd }}
                </td>
              </tr>
              <tr>
                <td class="text-right">
                  <strong>TOTAL FOLLETOS</strong>
                </td>
                <td class="text-center">
                  {{ infoCaja.total }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense>
          <template #default>
            <thead>
              <tr>
                <th class="text-left" colspan="2">
                  <h3>OTRO MATERIAL</h3>
                </th>
              </tr>
              <tr>
                <th class="text-left">
                  Nombre
                </th>
                <th class="text-center">
                  Cantidad
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>SANITARIO</td>
                <td class="text-center">
                  {{ infoCaja.sanitario }}
                </td>
              </tr>
              <tr>
                <td>MATERIALES</td>
                <td class="text-center">
                  {{ infoCaja.varios }}
                </td>
              </tr>
              <tr>
                <td>HOJAS RESPUESTAS</td>
                <td class="text-center">
                  {{ infoCaja.hojasRespuestas }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <br>
        <v-row>
          <v-col class="text-center">
            <strong>TOTAL GENERAL: {{ infoCaja.totalGeneral }}
            </strong>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
    <v-card-actions>
      <slot />
    </v-card-actions>
  </v-card>
</template>

<script>
import graphql from '../../utils/graphql';

export default {
  props: {
    local: {
      type: Object,
      default: null
    },
  },
  data: function() {
    return {
      infoCaja: null,
      showAlert: false,
    }
  },
  mounted() {
    this.caja();
  },
  methods: {
    async caja() {
      const {fspCodigo, sedCodigo, lapCodigo} = this.local;
      try {
        const query = {
          query: `
              query ($fspCodigo: Int!, $sedCodigo: Int!, $lapCodigo: Int!) {
                caja: cajaByLocalSedeFase(fspCodigo: $fspCodigo, sedCodigo: $sedCodigo, lapCodigo: $lapCodigo) {
                    leng
                    mate
                    hcso
                    cien
                    mate2
                    lengPesd
                    matePesd
                    hcsoPesd
                    cienPesd
                    mate2Pesd
                    total
                    sanitario
                    varios
                    hojasRespuestas
                    totalGeneral
                }
              }
            `,
          variables : {
            fspCodigo,
            sedCodigo,
            lapCodigo,
          }
        };
        const { caja } = await graphql.request(query);
        if (!caja) {
          this.showAlert = true;
        }
        this.infoCaja = caja;
      } catch (err) {
        this.$store.commit('error-notification', err.message);
      }
    }
  }
};
</script>
